import * as React from 'react';
const { connect } = require('react-redux');
import { reduxForm, InjectedFormProps, change, Field } from 'redux-form';
import { Modal } from 'components';
import { IModalAction } from 'models/modal';
import { PortalPageSection } from 'components/PortalStructure';
import { PortalInputField } from 'components/FormControls';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import {
	ManageSectionItemArticle,
	ManageSectionItemPoll,
	ManageSectionItemProduct,
	ManageSectionItemProfile,
	ManageSectionItemShop,
} from 'components/PortalPage/SectionItems';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { ButtonsSection } from 'components/PortalStructure';
import { Button, ErrorSummary } from 'components';
require('components/Tabs/style.css');
require('./../../style.css');

interface IProps extends InjectedFormProps {
	section: IPortalPageSection;
	baseUrl?: string;
	currentFormValues: IPortalPageSection;
	showHeaderCloseButton: boolean;
	index: number;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* function props */
	change?: (field: any, value: any) => void;
	saveSection?: (form: IPortalPageSection, index?: number) => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	error: boolean;
	message: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType4Form extends React.Component<IProps, IState> {
	private selectedCardType: string = '';

	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
		};

		if (this.props.section && this.props.section.cardType && this.props.section.cardType.length > 0) {
			this.selectedCardType = this.props.section.cardType;
		}

		this.onItemTypeChange = this.onItemTypeChange.bind(this);
		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	public componentDidMount() {
		this.onItemTypeChange(c.PORTAL_PAGE_SECTION_ITEM_SHOP);
	}

	private onSubmit(form: IPortalPageSection) {
		const getImageUrl = (data: IPortalPageSection['items'][number]) => (data.elements?.[0] as any)?.imageUrl;
		const itemWithImage = form.items.find(getImageUrl);
		form.seoImageUrl = itemWithImage ? getImageUrl(itemWithImage) : '';
		this.props.saveSection(form, this.props.index);
	}

	private setError(error: any) {
		this.setState({
			error: true,
			message: error,
		});
	}

	private clearError() {
		this.setState({
			error: false,
			message: null,
		});
	}

	private onItemTypeChange(item: string) {
		this.selectedCardType = item;
		this.props.change('cardType', item);
		this.clearError();
		this.forceUpdate();
	}

	private getFormContent(type: string) {
		const { ...props } = this.props;
		const { t } = this.props;
		const tabs = [];
		const tabsContents = [];

		for (let i: number = 1; i <= 9; i++) {
			tabs.push(
				<TabLink key={i} className="tab" to={`box${i + 1}`}>
					<span>{t('Magazine_Section_Manage_Common_Label_Box') + i}</span>
				</TabLink>,
			);

			let tabContent = null;

			switch (type) {
				case c.PORTAL_PAGE_SECTION_ITEM_ARTICLE:
					tabContent = (
						<TabContent key={i} for={`box${i + 1}`}>
							<ManageSectionItemArticle index={i} {...props} setError={this.setError} clearError={this.clearError} />
						</TabContent>
					);
					break;
				case c.PORTAL_PAGE_SECTION_ITEM_POLL:
					tabContent = (
						<TabContent key={i} for={`box${i + 1}`}>
							<ManageSectionItemPoll index={i} {...props} />
						</TabContent>
					);
					break;
				case c.PORTAL_PAGE_SECTION_ITEM_PRODUCT:
					tabContent = (
						<TabContent key={i} for={`box${i + 1}`}>
							<ManageSectionItemProduct index={i} {...props} setError={this.setError} clearError={this.clearError} />
						</TabContent>
					);
					break;
				case c.PORTAL_PAGE_SECTION_ITEM_PROFILE:
					tabContent = (
						<TabContent key={i} for={`box${i + 1}`}>
							<ManageSectionItemProfile index={i} {...props} setError={this.setError} clearError={this.clearError} />
						</TabContent>
					);
					break;
				case c.PORTAL_PAGE_SECTION_ITEM_SHOP:
					tabContent = (
						<TabContent key={i} for={`box${i + 1}`}>
							<ManageSectionItemShop index={i} {...props} setError={this.setError} clearError={this.clearError} />
						</TabContent>
					);
					break;
				default:
					tabContent = null;
			}

			tabsContents.push(tabContent);
		}

		return (
			<Tabs name="sectionItemSelectorTabs" tabComponent="div">
				<div className="tabsHolder">{tabs}</div>
				<div className="tabsContent">{tabsContents}</div>
			</Tabs>
		);
	}

	public render() {
		const { error, message } = this.state;
		const { pristine, submitting, handleSubmit, t, showHeaderCloseButton, closeModal } = this.props;
		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<Modal
				title={t('PortalPage_Section_Manage_Common_EditSection')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="portalPageSectionManageWrapper"
			>
				<div>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<PortalPageSection usage="admin">
						<div className="row">
							<div className="col-md-12">
								<Field
									name={`items[0].elements[0].text`}
									component={PortalInputField}
									usage="admin"
									type="text"
									label={t('PortalPage_Section_Type4_Label_Title')}
								/>
							</div>
						</div>
					</PortalPageSection>
					{this.selectedCardType && this.selectedCardType.length > 0 ? (
						<form onSubmit={handleSubmit(this.onSubmit)}>
							{this.getFormContent(this.selectedCardType)}
							<ButtonsSection>
								<div className="row">
									<div className="col-sm-12">
										<Button type="submit" usage="admin" disabled={pristine || submitting}>
											{t('BSPortal_Common_SaveAndClose')}
										</Button>
									</div>
								</div>
							</ButtonsSection>
						</form>
					) : null}
				</div>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	const newProps = {
		type: c.PORTAL_PAGE_SECTION_TYPE_4,
		items: [],
	};

	let currentFormValues: IPortalPageSection = null;
	if (state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION4] && state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION4].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION4].values;
	}

	return {
		initialValues: ownProps.section || newProps,
		currentFormValues,
	};
}

let ManageType4 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION4,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType4Form);

ManageType4 = connect(mapStateToProps, (dispatch) => ({
	dispatch,
	change: (field: string, value: string) => dispatch(change(field, value)),
}))(ManageType4);

export { ManageType4 };
